export default {"src":"/_next/static/image/src/images/onboarding/food-bowl.2171eafdf21b7fd6ae66969405db062e.svg","height":92,"width":103};